export default "__VITE_ASSET__BVgvNf$L__"